// 引き渡された値がJSON文字列であればパースして返し、そうでなければそのまま返す
export const parseIfJson = <T>(value: any): T | any => {
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
